module.exports = __webpack_public_path__ + "img/bodyframe.095207d3.png";